<template>
  <div class="vue-edit-county-wrap">
    <div class="controls-container-wrapper">
        <div class="selected-county-container" v-if="selectedCounty && selectedCountyForEdit">
        <!-- name -->
        <div class="controls-container">
            <div class="control">
            <label for="name">Name:</label>
            <input v-model="selectedCountyForEdit.name" placeholder="County name" type="text" class="name" v-bind:disabled="updatingCounty">
            </div>
        </div>
        <!-- code -->
        <div class="controls-container">
            <div class="control">
            <label for="code">Code:</label>
            <input v-model="selectedCountyForEdit.code" placeholder="County code" type="text" class="code" v-bind:disabled="updatingCounty">
            </div>
        </div>
        </div>
    </div>
    <div
    v-if="errorMessage"
    class="error-message">{{errorMessage}}</div>
    <div class="edit-county-footer">
        <b-spinner v-if="updatingCounty" class="ajax-spinner"></b-spinner>
      <template>
          <b-button
          class="cancel"
          @click="cancel"
          v-bind:disabled="updatingCounty"
          v-if="!updatingCounty && !deleteMode">Cancel</b-button>
          <b-button
          class="update"
          @click="updateCounty"
          v-bind:disabled="updatingCounty"
          v-if="!updatingCounty && !deleteMode">Update County</b-button>
          <span
          class="delete-button-container"
          v-if="!updatingCounty">
          <delete-button-with-confirm
          :deleteClicked="onDeleteButtonClicked"
          :cancelClicked="onDeleteCancelButtonClicked"
          :deleteConfirmClicked="onDeleteConfirmButtonClicked"
          :buttonText="'Delete ' + selectedCountyForEdit.name"
          :confirmText="'Confirm delete: ' + selectedCountyForEdit.name"></delete-button-with-confirm>
          </span>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import DeleteButtonWithConfirm from "../../../../../shared/buttons/delete-button-with-confirm/DeleteButtonWithConfirm";

export default {
  name: 'EditCounty',
  components: {
    DeleteButtonWithConfirm
  },
  props: {
    selectedCounty: Object,
    getAllCounties: Function,
    destroySelectedCounty: Function,
    countyUpdateSuccessMessage: Function
  },
  data() {
    return {
      deleteMode: false,
      updatingCounty: false,
      errorMessage: undefined,
      selectedCountyForEdit: undefined
    }
  },
  async created() {
    this.updateSelectedCountyForEdit(this.selectedCounty);
  },
  watch: {
    selectedCounty: function (selectedCounty) {
      this.updateSelectedCountyForEdit(selectedCounty);
    }
  },
  methods: {
      hideModal() {
        this.destroySelectedCounty();
      },
      cancel() {
        this.destroySelectedCounty();
      },
      updateSelectedCountyForEdit(selectedCounty) {
        this .selectedCountyForEdit = JSON.parse(JSON.stringify(selectedCounty));
      },
      onDeleteButtonClicked() {
        this.deleteMode = true;
      },
      onDeleteCancelButtonClicked() {
        this.deleteMode = false;
      },
      onDeleteConfirmButtonClicked() {
        this.deleteCounty();
      },
      deleteCounty() {
        this.errorMessage = false;
        this.updatingCounty = true;
        try {
          API.DeleteCounty(this.selectedCounty.countyId).then(() => {
            this.updatingCounty = false;
            this.$forceUpdate();
            this.destroySelectedCounty();
            this.countyUpdateSuccessMessage(`${this.selectedCounty.name} deleteed`);
            this.getAllCounties();
          }, err => {
            this.updatingCounty = false;
            console.error('DeleteCounty - ERROR');
            console.dir(err);
            if (err
            && err.response
            && err.response.data) {
              this.errorMessage = err.response.data;
            } else {
                this.errorMessage = `Error deleting ${this.selectedCounty.name}`;
            }
          })
        } catch (err) {
            this.updatingCounty = false;
            console.error('DeleteCounty - catch - ERROR!');
            console.dir(err);
            this.$forceUpdate();
        }
      },
      updateCounty() {
        this.errorMessage = false;
        this.updatingCounty = true;
        try {
          API.UpdateCounty(this.selectedCountyForEdit).then(() => {
            this.updatingCounty = false;
            this.getAllCounties();
            this.countyUpdateSuccessMessage(`${this.selectedCountyForEdit.name} county updated`);
            this.destroySelectedCounty();
          }, err => {
            console.error('UpdateCounty - ERROR');
            console.dir(err);
            this.updatingCounty = false;
            if (err
            && err.response
            && err.response.data) {
              this.errorMessage = err.response.data;
            } else {
                this.errorMessage = `Error updating ${this.selectedCountyForEdit.name}`;
            }
          })
        } catch (err) {
            this.updatingCounty = false;
            console.error('POST ERROR!');
            console.dir(err);
        }
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../../assets/css/partials/_variables.scss";

.ajax-spinner{
  position: relative;
  top: 5px;
  left: 0px;
  height: 40px;
  width: 40px;
  font-size: 22px;
  color: #fbd850;
}

.controls-container-wrapper{
  margin-top: 20px;

  .controls-container {
    width: 80%;
    margin-bottom: 20px;
    padding: 10px;
    background-color: $modalGrey;

    input[type="text"] {
      width: 100%;
      height: 40px;
      padding-left: 10px;
      border: none;
    }

    .header{
      margin: 10px 0 0 5px;
      font-weight: bold
    }

    label {
      margin-right: 10px;
      font-weight: bold;
    }

    input[type="text"] {
      width: 100%;
    }

    h4{
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.error-message{
  margin: 20px 0;
  font-weight: bold;
  color: #800000;
}

.edit-county-footer{
  .btn{
    margin-right: 10px;

    &:last-child{
      margin-right: 0;
    }
  }
}
</style>
